module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/camera_porch-76a85103f26ac07083ebdf8c9cb183c8.png";